import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { queryParamsModule } from '@/modules/queryParams';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OnboardingFooter } from '../../../../components/Footer';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '../../../../components/List';
import { OnboardingNavigation } from '../../../../components/Navigation';
import { OnboardingPage } from '../../../../components/Page';
import { OnboardingTitle } from '../../../../components/Title';
import { useOnboarding } from '../../../../context';
import { LayoutDataKeyType, LayoutDataType } from '../../types';

import { TOPICS_OPTIONS } from './constants';
import './Topics.scss';

export const OnboardingReplikaTopics: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Topics',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const topics = form.watch('topics');

  const handleNextStep = (): void => {
    const selectedTopicOption = TOPICS_OPTIONS.find(
      (option) => option.id === topics,
    );
    userService.createOrUpdate({
      onboarding_data: {
        topics: selectedTopicOption?.title || '',
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage className="onboarding-topics">
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle className="onboarding-topics__title">
          What are you mostly looking for in Dialogue?
        </OnboardingTitle>
        <OnboardingOptionsList>
          {TOPICS_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={topics?.includes(option.id) ?? false}
              control={form.control}
              option={option}
              name="topics"
              key={option.id}
              onChange={(value) => {
                queryParamsModule.setParam<LayoutDataKeyType>('topics', value);
              }}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} disabled={!topics} />
    </OnboardingPage>
  );
};
